<template>
  <div style="height: 100%;">
    <div style="height: 5%;">
      <el-select v-model="about_id" size="mini" clearable placeholder="请选择">
        <el-option
          v-for="item in aboutList"
          :key="item.id"
          :label="item.time*1 | formatDate"
          :value="item">
        </el-option>
      </el-select>
      <el-button type="primary" class="btn" size="mini" @click="UpdateNewAbout()"><i class="el-icon-edit"></i>修改历史版本</el-button>
      <el-button type="primary" class="btn" size="mini" @click="AddNewAbout()"><i class="el-icon-circle-plus-outline"></i>编写新内容</el-button>
    </div>
    <mavon-editor style="height: 95%;" ref=md v-model="content" @imgAdd="imgAdd" @imgDel="imgDel" @save="saveDoc"></mavon-editor>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import axios from 'axios' //引入axios
export default {
  data () {
    return {
      //历史版本ID
      about_id:'',
      aboutdata:{
        id:'',
        admin_id:'',
        content:'',
        html:'',
        type:'',
      },
      aboutList:'',
      //
      content:'',
      //管理员相关信息
      AdminInfor:{
        id:'',
        name:'',
        photo:'',
        type:'',
      },
      formInline: {
        type:'',
      },
    }
  },
  filters: {
        formatDate: function (value) {
          /*返回总体日期*/
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          /*返回判断日期*/
          let timestamp = (new Date()).valueOf();
          let time=timestamp-value;//时间差
          let minute = 1000*60;
          let hour = minute * 60;
          var day = hour * 24;
          let times="";//内容
          let min = time/minute;//分钟
          let hours = time/hour;//天数
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
      },
  //页面开启时执行
  mounted(){
    this.queryAllAbout()
    this.chark();
  },
  methods: {
    //进行判定
    chark(){
      this.$emit("parentHandle", 2)
    },
    //添加新内容
    AddNewAbout(){
      this.aboutdata.id="";
      this.aboutdata.type="add";
      for(let i=0;i<this.aboutList.length;i++){
        if(this.aboutList[i].type=="1"){
          this.content=this.aboutList[i].content;
          break;
        }
      }
    },
    //修改内容
    UpdateNewAbout(){
      this.aboutdata.type="update";
      this.content=this.about_id.content;
      this.aboutdata.id=this.about_id.id;
    },
    //查询所有的版本信息
    queryAllAbout(){
      commonAPI('queryAbout',this.formInline).then(res => {
        this.loading = false;
        this.aboutList = res.data.data.rows;
        //console.log(res.data.rows);
      })
    },
    //获取信息方法
    judgeLogin(){
      this.AdminInfor.id=this.$store.state.a_id;
    },
    saveDoc(markdown, html) {
      if(this.content.length<=0){
        this.$message({
          message: '请填写内容后再保存',
          type: 'warning'
        });
        return false;
      }
      let admin_id=this.$store.state.a_id;
      this.aboutdata.admin_id=admin_id;
      //this.aboutdata.type="update";
      this.aboutdata.content=markdown;
      this.aboutdata.html=html;
      //console.log(index, row);
      commonAPI('SaveAbout',this.aboutdata).then(res => {
        let data = res.data;
        //console.log(res.data.rows);
        if(this.response.response(data)){
          this.queryAllAbout();
        }
      }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
        })
    },
    imgAdd(name, file) {
      var formdata = new FormData();
      formdata.append('image', file);
      axios({
        url: '/api/AddAboutIMG',
        method: 'post',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((res) => {
        let url=res.data.data
        this.$refs.md.$img2Url(name, url);
      })
    },
    imgDel(name){
      console.log("name内容:" + name);
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/admin/views/system/About_Our.vue